// @flow

import { combineReducers, type Reducer } from 'redux';

import {
  createSequoiaResource,
  type SequoiaResource,
  type SequoiaResourceType,
  type ListState,
  type ResourceAction,
} from '@gandi/resource/redux';

export type TemplateSummary = {
  name: string,
  price: {
    currency: string,
    price_after_taxes: number,
  },
  server: {
    cores: number,
    memory: number,
    ips: Array<{
      version: 4 | 6,
    }>,
    volumes: Array<{
      size: number,
    }>,
    ipv4: number,
    ipv6: number,
    storage: number,
  },
  type: 'server' | string,
};

export type State = {
  list: ListState<TemplateSummary>,
};

type TemplatesResourceType = SequoiaResourceType<{
  fetchResource: TemplateSummary,
}>;

export type TemplatesResource = SequoiaResource<TemplatesResourceType>;

export const templatesResource: TemplatesResource = createSequoiaResource(
  'cloud',
  'templates',
  {
    fetchPath: 'hosting/templates',
    getResourceId(resource) {
      return resource.name;
    },
    getFetchResponseData(response) {
      return response.data.map(data => ({
        ...data,
        server: {
          ...data.server,
          ipv4: data.server.ips.reduce(
            (acc, ip) => (ip.version === 4 ? acc + 1 : acc),
            0,
          ),
          ipv6: data.server.ips.reduce(
            (acc, ip) => (ip.version === 6 ? acc + 1 : acc),
            0,
          ),
          storage: data.server.volumes.reduce(
            (acc, volume) => acc + volume.size,
            0,
          ),
        },
      }));
    },
  },
);

export const reducer: Reducer<State, ResourceAction<>> = combineReducers({
  ...templatesResource.listReducer,
});
